/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nudge_Enable_Notetaker_TitleInputs */



/**
* | output |
* | --- |
* | "Notetaker" |
*
* @param {Nudge_Enable_Notetaker_TitleInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const nudge_enable_notetaker_title = /** @type {((inputs?: Nudge_Enable_Notetaker_TitleInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nudge_Enable_Notetaker_TitleInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Notetaker")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Notetaker")
	return /** @type {LocalizedString} */ ("Notetaker")
});